import React from 'react';

const WHATSAPP_URL = 'https://wa.me/919873243456?text=' + encodeURIComponent('Hi, I would like to know more about the awards.');

const WhatsAppFloat = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    data-testid="whatsapp-float"
    className="fixed z-[60] bottom-5 right-5 md:bottom-7 md:right-7 group"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366]/50 animate-ping" aria-hidden />
    <span
      className="relative flex items-center justify-center w-13 h-13 md:w-14 md:h-14 rounded-full text-white shadow-[0_18px_40px_-10px_rgba(37,211,102,0.55)] transition-transform duration-300 group-hover:scale-110"
      style={{ width: 54, height: 54, background: 'linear-gradient(140deg, #25D366 0%, #128C7E 100%)' }}
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="currentColor" aria-hidden>
        <path d="M16.001 3C8.82 3 3 8.82 3 16c0 2.291.602 4.524 1.748 6.49L3 29l6.66-1.745A12.945 12.945 0 0 0 16 29c7.18 0 13-5.82 13-13S23.181 3 16.001 3Zm0 23.5c-1.96 0-3.875-.521-5.555-1.51l-.398-.237-3.953 1.035 1.054-3.851-.259-.41A10.43 10.43 0 0 1 5.5 16C5.5 10.21 10.21 5.5 16 5.5S26.5 10.21 26.5 16 21.791 26.5 16 26.5Zm5.96-7.84c-.326-.163-1.927-.951-2.226-1.06-.298-.108-.515-.163-.733.164-.218.326-.842 1.06-1.033 1.278-.19.218-.38.245-.706.082-.327-.163-1.378-.508-2.625-1.621-.97-.866-1.624-1.937-1.814-2.264-.19-.326-.02-.502.143-.665.146-.146.327-.38.49-.57.163-.19.218-.326.327-.544.108-.218.054-.408-.027-.571-.082-.163-.733-1.764-1.005-2.418-.265-.635-.534-.55-.733-.56l-.625-.012a1.197 1.197 0 0 0-.87.408c-.298.327-1.14 1.114-1.14 2.717s1.168 3.151 1.331 3.369c.163.218 2.297 3.504 5.567 4.911.778.336 1.385.537 1.86.687.781.249 1.491.214 2.053.13.626-.094 1.927-.787 2.198-1.547.272-.76.272-1.413.19-1.547-.081-.135-.298-.218-.624-.381Z" />
      </svg>
    </span>
  </a>
);

export default WhatsAppFloat;
